export default __webpack_public_path__ + "static/media/fruits.aa3f5f95.jpg";